"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ModelStatus_1 = require("../types/ModelStatus");
const TracksType_1 = require("../types/TracksType");
const generateIndexes_1 = require("../utils/tracks/generateIndexes");
const notInitialized_1 = require("../utils/notInitialized");
class TracksModel {
    constructor() {
        this.tracks = [];
        this.filterString = '';
        this.status = ModelStatus_1.ModelStatus.Pending;
        this.playlistId = null;
        this.tracksType = TracksType_1.TracksType.Tracks;
        this.tracksTitle = 'Треки';
        this.onChange = notInitialized_1.notInitialized;
        this.onUpdate = notInitialized_1.notInitialized;
    }
    allWithSearch() {
        return this.tracks.filter((track) => {
            const filter = this.filterString.toLowerCase();
            return (track.name.toLowerCase().includes(filter) ||
                track.artist.name.toLowerCase().includes(filter) ||
                track.album.name.toLowerCase().includes(filter));
        });
    }
    all() {
        return this.tracks;
    }
    setAll(tracks) {
        this.tracks = tracks.map((track, index) => Object.assign(track, { index }));
    }
    get(id) {
        return this.findById(id);
    }
    add(track) {
        const index = this.tracks.length;
        this.tracks.push(Object.assign(track, { index }));
    }
    update(track, id) {
        const index = this.tracks.findIndex((track) => track.id === id);
        this.tracks[index] = Object.assign(track, { index });
    }
    delete(id) {
        this.tracks.filter((track) => track.id !== id);
        this.recalculateIndexes();
    }
    findById(id) {
        const track = this.tracks.filter((track) => track.id === id)[0];
        if (!track) {
            throw new Error(`Track with id: ${id} not found`);
        }
        return track;
    }
    recalculateIndexes() {
        this.tracks = (0, generateIndexes_1.generateIndexes)(this.tracks);
    }
}
exports.default = TracksModel;
